import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://welthandel-backend.vercel.app/api',
});

// Request interceptor for admin headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  const adminData = localStorage.getItem('adminData');
  const adminEmail = adminData ? JSON.parse(adminData).email : null;
  
  if (token && adminEmail) {
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['email'] = adminEmail;
  }
  return config;
});

// Response interceptor for handling 401 errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminRefreshToken');
      localStorage.removeItem('adminData');
      window.location.href = '/admin_login';
    }
    return Promise.reject(error);
  }
);

export default api;